import React, { useRef } from 'react';
import TableComponent from '../Table';
import './index.scss';

export const Tables: React.FunctionComponent<{id: number}> = ({ id }) => {
  const divRef = useRef<HTMLDivElement>(null);
  return (
    <div ref={divRef} id={'table-' + id} className='table-canvas-multi'>
      <TableComponent id={id} parentRef={divRef} />
    </div>
  )
};

export default Tables;
